import { render, staticRenderFns } from "./TriggersPage.vue?vue&type=template&id=1d1919a4&"
import script from "./TriggersPage.vue?vue&type=script&lang=js&"
export * from "./TriggersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports